import {Outlet} from 'react-router-dom';

import Texts from "../utilis/defaults/Text";
import HeadInfo from "../components/HeadInfo"
import Container from '../components/Container';
import {useContext, useEffect, useState} from "react";
import AuthContext from "../utilis/contexts/AuthContext";
import {Divider} from "antd";
import AppContext from "../utilis/contexts/AppContext";
import ValueLabel from "../utilis/models/valueLabel";
import getServiceName from "../utilis/helpers/getServiceName";
import Api from "../utilis/api/service";
import Urls from "../utilis/api/Urls";
import {Skeleton} from "antd";
import ServiceCode from "../utilis/enums/ServiceCode";

const Service = () => {

    const authContext = useContext(AuthContext)
    const appContext = useContext(AppContext);
    const {globalData} = appContext;
    // @ts-ignore
    const {cities} = globalData;

    const {data: Data, authenticated} = authContext;

    const [branchDefaults, setBranchDefaults] = useState<any>();
    const [isLoading, setLoading] = useState(true)
    // @ts-ignore
    const {data: CurrentData} = Data;

    useEffect(() => {
        Api.post(Urls.GetBranchDefaultValues, {
            Cellphone: CurrentData.cellphone,
            BillId: CurrentData.bill_id
        }, {
            headers: {
                "Authorization": `Bearer ${CurrentData.access_token}`
            }
        }).then(({data}) => {

            setBranchDefaults(data.Data.branch_info);
            authContext.handleData({
                data: {
                    ...CurrentData,
                    ...data.Data.branch_info,
                }
            });
        }).finally(() => {
            setLoading(false)
        })
    }, [])
    if ((CurrentData.service_type === ServiceCode.WaterBranchAssignment)|| CurrentData.service_type === ServiceCode.SaleTankerWater) {

        return <div className="w-full">
            <div className="service-hero mb-3">
                <Container className="z-20 relative">
                    <h1 className="text-center text-2xl font-bold text-white pb-10 border-b border-b-gray-100 z-20">
                        {Texts.appName}
                    </h1>
                    <h3 className="text-lg z-20 font-light text-center  text-white">{getServiceName(CurrentData.service_type)}</h3>
                </Container>
                <div className="divider "/>


            </div>
            {isLoading && <Container>
                <Skeleton  active />
            </Container>}
            {!isLoading &&
                <Container className="bg-gray-100   mb-5 border-t p-5">
                    <Outlet context={{
                        branchDefaults:branchDefaults
                    }}/>
                </Container>
            }
        </div>
    }
    return <div className=" w-full">
        <div className="service-hero">
            <Container className="z-20 relative">
                <h1 className="text-center text-2xl font-bold text-white pb-10 border-b border-b-gray-100 z-20">
                    {Texts.appName}
                </h1>
                <h3 className="text-lg z-20 font-light text-center  text-white">{getServiceName(CurrentData.service_type)}</h3>
            </Container>
            <div className="divider "/>


        </div>

        <Container className=" p-5 bg-white   bg-gray-50 rounded-t-lg  mt-4">

            <Divider orientation="center"><h3
                className="text-center font-bold text-xl my-3">{Texts.branchInformation}</h3></Divider>
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-3">
                {/*
                <HeadInfo name={Texts.city}
                          value={cities.find((city: ValueLabel) => CurrentData.city == city.value).label}/>*/}
                <HeadInfo name={Texts.city}
                          value={CurrentData.city_name}/>
                <HeadInfo name={Texts.fileNumber} value={CurrentData.file_number}/>
                <HeadInfo name={Texts.firstName} value={CurrentData.first_name}/>
                <HeadInfo name={Texts.lastName} value={CurrentData.last_name}/>
                <HeadInfo name={Texts.prevReadingDate} value={CurrentData.previous_date}/>
                <HeadInfo name={Texts.prevReadingNumber} value={CurrentData.previous_number}/>
                {!authenticated && <>    <HeadInfo name={Texts.postalCode} value={CurrentData.postal_code}/>
                    <HeadInfo name={Texts.nationalId} value={CurrentData.national_code}/></>}
            </div>
            {!authenticated && <>
                <HeadInfo name={Texts.address} value={CurrentData.address}/>
                <HeadInfo name={Texts.description} value={CurrentData.description}/>
            </>}

        </Container>

        {isLoading && <Container>
            <Skeleton active/>
        </Container>}
        {!isLoading &&
            <Container className="bg-gray-100   mb-5 border-t p-5">
                <Outlet context={{
                    branchDefaults: branchDefaults
                }}/>
            </Container>
        }
    </div>
}
export default Service;